<div class="modal-banner-container">
  <div  *ngIf="timer" ><button (click)="close()" class="close-button">&times;</button> </div>
  <img class="modal-image" *ngIf="data.FileUrl" [src]="data.FileUrl  | secureImage | async" [alt]="data.FileName" (click)="openUrl()">
</div>
